/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shared_Success_TitleInputs */

const en_shared_success_title = /** @type {(inputs: Shared_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shared!`)
};

const es_shared_success_title = /** @type {(inputs: Shared_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Compartido!`)
};

const fr_shared_success_title = /** @type {(inputs: Shared_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partagé !`)
};

const de_shared_success_title = /** @type {(inputs: Shared_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geteilt!`)
};

const id_shared_success_title = /** @type {(inputs: Shared_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dibagikan!`)
};

/** @type {(inputs: Shared_Success_TitleInputs) => LocalizedString} */
const ja_shared_success_title = en_shared_success_title;

/** @type {(inputs: Shared_Success_TitleInputs) => LocalizedString} */
const zh_shared_success_title = en_shared_success_title;

/** @type {(inputs: Shared_Success_TitleInputs) => LocalizedString} */
const ar_shared_success_title = en_shared_success_title;

/** @type {(inputs: Shared_Success_TitleInputs) => LocalizedString} */
const it_shared_success_title = en_shared_success_title;

/** @type {(inputs: Shared_Success_TitleInputs) => LocalizedString} */
const ru_shared_success_title = en_shared_success_title;

/** @type {(inputs: Shared_Success_TitleInputs) => LocalizedString} */
const pt_shared_success_title = en_shared_success_title;

/** @type {(inputs: Shared_Success_TitleInputs) => LocalizedString} */
const ko_shared_success_title = en_shared_success_title;

/**
* | output |
* | --- |
* | "Shared!" |
*
* @param {Shared_Success_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const shared_success_title = /** @type {((inputs?: Shared_Success_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shared_Success_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shared_success_title(inputs)
	if (locale === "es") return es_shared_success_title(inputs)
	if (locale === "fr") return fr_shared_success_title(inputs)
	if (locale === "de") return de_shared_success_title(inputs)
	if (locale === "ja") return ja_shared_success_title(inputs)
	if (locale === "zh") return zh_shared_success_title(inputs)
	if (locale === "ar") return ar_shared_success_title(inputs)
	if (locale === "id") return id_shared_success_title(inputs)
	if (locale === "it") return it_shared_success_title(inputs)
	if (locale === "ru") return ru_shared_success_title(inputs)
	if (locale === "pt") return pt_shared_success_title(inputs)
	return ko_shared_success_title(inputs)
});